import dayjs, { Dayjs } from 'dayjs'
import { z } from 'zod'

export const daySchema = z.custom<Dayjs>((value) => dayjs(value).isValid())
